import { useEffect } from "react";
import { SITE_ORIGIN, DEFAULT_OG_IMAGE } from "@/content/projects";

function upsertMeta(attr, key, content) {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-route document metadata without adding a Helmet dependency.
 * Fail-open: missing fields fall back to site defaults.
 */
export default function PageMeta({
  title,
  description,
  path = "/",
  image,
  imageAlt = "SoKno Productions — gold curtain logo",
  robots = "index, follow",
  type = "website",
  noindex = false,
}) {
  useEffect(() => {
    const fullTitle = title || "SoKno Productions | Bold Independent Film Studio";
    const desc =
      description ||
      "SoKno Productions is a Dallas-based independent film company developing original films, creative partnerships, and opportunities for talent, filmmakers, and production collaborators.";
    const canonical = path.startsWith("http")
      ? path
      : `${SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
    const ogImage = image || DEFAULT_OG_IMAGE;
    const robotsContent = noindex ? "noindex, nofollow" : robots;

    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("name", "robots", robotsContent);
    upsertLink("canonical", canonical);

    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", "SoKno Productions");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:image:alt", imageAlt);
    upsertMeta("property", "og:locale", "en_US");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", ogImage);

    document.documentElement.lang = "en";
  }, [title, description, path, image, imageAlt, robots, type, noindex]);

  return null;
}
